import React, { useState } from 'react';
import { Navbar, Button, Container } from 'react-bootstrap';
import Sidebar from '../Sidebar/Sidebar';

const NavbarMobile = () => {
    const [showSidebar, setShowSidebar] = useState(false);

    const handleShowSidebar = () => setShowSidebar(true);
    const handleCloseSidebar = () => setShowSidebar(false);

    const cooperative = JSON.parse(localStorage.getItem("cooperative"));
    const name = cooperative?.name?.length > 30 ? cooperative.name.substring(0, 30) + "..." : (cooperative?.name || "--");

    return (
        <>
            <Navbar
                expand={false}
                className="navbar-mobile sticky-top"
            >
                <Container fluid className="navbar-mobile__content">
                    <Button
                        className="navbar-mobile__menu-btn"
                        variant="link"
                        onClick={handleShowSidebar}
                        aria-label="Abrir menu principal"
                    >
                        ☰
                    </Button>
                    <h4 className="navbar-mobile__title">{name}</h4>
                </Container>
            </Navbar>
            <Sidebar show={showSidebar} handleClose={handleCloseSidebar} />
        </>
    );
};

export default NavbarMobile;
